import { FloraTypography } from '@grupoboticario/flora-react';

import Styles from './Login.components.styles';

import { Link } from 'ui/components';

export const SecurityUtilLinks = () => {
  return (
    <Styles.SecurityWrapper>
      <FloraTypography as="span" fontSize="bodySmallStandard" css={{ textAlign: 'center' }}>
        Os seus dados serão tratados de acordo com a nossa{' '}
        <Link to="https://privacidade.grupoboticario.com.br/" target="_blank">
          <FloraTypography
            autotagging-flora="on"
            data-flora-text="politica-de-privacidade"
            data-flora="button"
            fontSize="bodySmallShort"
            textDecoration="underline"
            as="span"
            css={{ color: '$actionableDefault' }}
          >
            Política de Privacidade.
          </FloraTypography>
        </Link>
        <br />
        <Link to="https://privacidade.grupoboticario.com.br/proteja-se.html" target="_blank">
          <FloraTypography
            autotagging-flora="on"
            data-flora-text="click:proteja-se-contra-fraudes"
            data-flora="button"
            fontSize="bodySmallShort"
            textDecoration="underline"
            as="span"
            css={{ color: '$actionableDefault' }}
          >
            Proteja-se contra fraudes.
          </FloraTypography>
        </Link>
      </FloraTypography>
    </Styles.SecurityWrapper>
  );
};
